"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldHidePlaceholder = shouldHidePlaceholder;
exports.contentHasValidText = exports.isReactComponent = exports.isReactElement = exports.getMemoizedPages = exports.getTemporaryTitle = exports.getTitlePlaceholder = exports.getCompositionTypeString = exports.getMessageRenderer = exports.callIfPossible = exports.immutablePick = exports.getRelevantGates = exports.createAction = exports.getRootUrl = exports.getBaseUrl = void 0;

var _constants = require("./constants");

var _constants2 = require("composer-lib/lib/constants");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var getBaseUrl = function getBaseUrl() {
  return '/compose';
};

exports.getBaseUrl = getBaseUrl;

var getRootUrl = function getRootUrl() {
  return getBaseUrl() + "/" + _PortalIdParser.default.get();
}; // redux action creator


exports.getRootUrl = getRootUrl;

var createAction = function createAction(type) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var meta = arguments.length > 1 ? arguments[1] : undefined;
    return {
      type: type,
      data: data,
      meta: meta
    };
  };
};

exports.createAction = createAction;

var getRelevantGates = function getRelevantGates(arrayOfGates) {
  var gates = (0, _immutable.Set)(arrayOfGates);
  return gates.filter(function (gate) {
    return _constants.GATES.indexOf(gate) > -1;
  });
};

exports.getRelevantGates = getRelevantGates;

var immutablePick = function immutablePick(data, keysToPick) {
  var keySet = (0, _immutable.Set)(keysToPick).toMap();
  return keySet.map(function (key) {
    return data.get(key);
  });
};

exports.immutablePick = immutablePick;

var callIfPossible = function callIfPossible(prop) {
  if (typeof prop !== 'function') {
    return prop;
  }

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return prop.apply(void 0, args);
};

exports.callIfPossible = callIfPossible;

var getMessageRenderer = function getMessageRenderer(baseKey) {
  return function (key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var fullKey = baseKey + "." + key;

    var value = _I18n.default.lookup(fullKey);

    var hasHTML = /<("[^"]*"|'[^']*'|[^'">])*>/.test(value);
    var ComponentToRender = hasHTML ? _FormattedHTMLMessage.default : _FormattedMessage.default;
    return _react.default.createElement(ComponentToRender, {
      message: fullKey,
      options: options
    });
  };
};

exports.getMessageRenderer = getMessageRenderer;

var getCompositionTypeString = function getCompositionTypeString(typeValue) {
  switch (typeValue) {
    case _constants2.CompositionTypes.BLOG_POST:
      return 'blogPost';

    case _constants2.CompositionTypes.KNOWLEDGE_ARTICLE:
      return 'knowledgeArticle';

    case _constants2.CompositionTypes.PLAYBOOK:
      return 'playbook';

    default:
      return 'blogPost';
  }
};

exports.getCompositionTypeString = getCompositionTypeString;

var getTitlePlaceholder = function getTitlePlaceholder(compositionTypeString) {
  return _I18n.default.text("composer-lib.composer.titlePlaceholder." + compositionTypeString);
};

exports.getTitlePlaceholder = getTitlePlaceholder;

var getTemporaryTitle = function getTemporaryTitle(compositionTypeString) {
  var title = _I18n.default.lookup("composer-lib.composer.temporaryTitle." + compositionTypeString);

  return title || '';
};

exports.getTemporaryTitle = getTemporaryTitle;
var getMemoizedPages = (0, _memoize.default)(function (pages) {
  return pages.data.toJS();
}, function (pages) {
  return pages.hashCode();
});
exports.getMemoizedPages = getMemoizedPages;

var isReactElement = function isReactElement(element) {
  return _react.default.isValidElement(element) && typeof element.type === 'string';
};

exports.isReactElement = isReactElement;

var isReactComponent = function isReactComponent(element) {
  return _react.default.isValidElement(element) && typeof element.type === 'function';
};

exports.isReactComponent = isReactComponent;

var contentHasValidText = function contentHasValidText(saveState) {
  var content = saveState.content;
  return content && content.getCurrentContent().hasText();
}; // Taken from https://github.com/springload/draftail/blob/4ff6be3b8134881deaf51cda02f076183be7f358/lib/api/DraftUtils.js#L234-L243
// see also https://github.com/facebook/draft-js/issues/1205#issuecomment-358025861


exports.contentHasValidText = contentHasValidText;

function shouldHidePlaceholder(editorState) {
  var _RICH_TEXT_STYLES$BLO = _constants2.RICH_TEXT_STYLES.BLOCK_STYLES,
      LIST_STYLES = _RICH_TEXT_STYLES$BLO.LIST_STYLES,
      MISC_STYLES = _RICH_TEXT_STYLES$BLO.MISC_STYLES;
  var contentState = editorState.getCurrentContent();
  var contentType = contentState.getBlockMap().first().getType();

  var isUnstyled = function isUnstyled(item) {
    return [LIST_STYLES.ORDERED_LIST_ITEM, LIST_STYLES.UNORDERED_LIST_ITEM, MISC_STYLES.BLOCKQUOTE].includes(item);
  };

  return contentState.hasText() || isUnstyled(contentType);
}